export const ALERTS_PATH = "/api/alerts";
